import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getReporteVentas } from '../../../../service/reportes/ReporteVentas';

export interface DetalleVenta {
  folio_ticket: string;
  evento: string;
  venta_id: number;
  fecha_hora_venta: string;
  producto: string;
  cantidad: number;
  precio_unitario: number;
  total_venta: number;
  forma_pago: string;
  punto_venta_id: number;
  punto_venta: string;
  tipo_punto_venta: string;
}

export interface ResumenVenta {
  folio_ticket: string;
  evento: string;
  saldo_actual: number;
  activo: number;
  folio_nuevo: string | null;
  saldo_recarga_caja: number;
  total_consumido_puesto: number;
  transferido: number;
  balance: number;
  fecha_primera_venta: string;
}

export interface TicketConVentas {
  folio: string;
  resumen: ResumenVenta;
  detalle: DetalleVenta[];
}

export const useReporteVentas = (id_dia: number) => {
  const [list, setList] = useState<TicketConVentas[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!id_dia) {
      setList([]);
      return;
    }
    const fetchData = async () => {
      setLoadingRequest(true);
      try {
        const data = await getReporteVentas(id_dia);
        setList(data ?? []);
      } catch {
        history.push('/error/500');
      } finally {
        setLoadingRequest(false);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_dia]);

  return { list, loadingRequest };
};
